export function hexToString(hexString: string): string {
  const bytes = Uint8Array.from(
    hexString.match(/.{1,2}/g)?.map((byte) => parseInt(byte, 16)) || []
  );
  return new TextDecoder().decode(bytes);
}

export const isValidRedshiftColumnName = (name: string): boolean => {
  if (!name || name.length === 0 || name.length > 127) {
    return false;
  }

  // Must start with letter or underscore
  if (!/^[a-zA-Z_]/.test(name)) {
    return false;
  }

  // Can only contain letters, numbers, and underscores
  if (!/^[a-zA-Z0-9_]+$/.test(name)) {
    return false;
  }

  return true;
};

export const REDSHIFT_RESERVED_KEYWORDS = new Set([
  "aes128",
  "aes256",
  "all",
  "allowoverwrite",
  "analyse",
  "analyze",
  "and",
  "any",
  "array",
  "as",
  "asc",
  "authorization",
  "backup",
  "between",
  "binary",
  "blanksasnull",
  "both",
  "bytedict",
  "bzip2",
  "case",
  "cast",
  "check",
  "collate",
  "column",
  "constraint",
  "create",
  "credentials",
  "cross",
  "current_date",
  "current_time",
  "current_timestamp",
  "current_user",
  "current_user_id",
  "default",
  "deferrable",
  "deflate",
  "defrag",
  "delta",
  "delta32k",
  "desc",
  "disable",
  "distinct",
  "do",
  "else",
  "emptyasnull",
  "enable",
  "encode",
  "encrypt",
  "encryption",
  "end",
  "except",
  "explicit",
  "false",
  "for",
  "foreign",
  "freeze",
  "from",
  "full",
  "globaldict256",
  "globaldict64k",
  "grant",
  "group",
  "gzip",
  "having",
  "identity",
  "ignore",
  "ilike",
  "in",
  "initially",
  "inner",
  "intersect",
  "interval",
  "into",
  "is",
  "isnull",
  "join",
  "leading",
  "left",
  "like",
  "limit",
  "localtime",
  "localtimestamp",
  "lun",
  "luns",
  "lzo",
  "lzop",
  "minus",
  "mostly13",
  "mostly32",
  "mostly8",
  "natural",
  "new",
  "not",
  "notnull",
  "null",
  "nulls",
  "off",
  "offline",
  "offset",
  "oid",
  "old",
  "on",
  "only",
  "open",
  "or",
  "order",
  "outer",
  "overlaps",
  "parallel",
  "partition",
  "percent",
  "permissions",
  "placing",
  "primary",
  "raw",
  "readratio",
  "recover",
  "references",
  "respect",
  "rejectlog",
  "resort",
  "restore",
  "right",
  "select",
  "session_user",
  "similar",
  "snapshot",
  "some",
  "sysdate",
  "system",
  "table",
  "tag",
  "tdes",
  "text255",
  "text32k",
  "then",
  "timestamp",
  "to",
  "top",
  "trailing",
  "true",
  "truncatecolumns",
  "union",
  "unique",
  "user",
  "using",
  "verbose",
  "wallet",
  "when",
  "where",
  "with",
  "without",
]);
